module.exports = __webpack_public_path__ + "static/media/404.e8d079fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/404.png
// module id = 389
// module chunks = 14